
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryPackageDetailsEditor extends _Ext.GridEditorBase<SalaryPackageDetailsRow> {
        protected getColumnsKey() { return 'HR.SalaryPackageDetails'; }
        protected getDialogType() { return SalaryPackageDetailsDialog; }
        protected getLocalTextPrefix() { return SalaryPackageDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}